<template>
  <div>
    <van-search
        v-model="value"
        clearable
        shape="round"
        @input="onSearch"
        @search="onSearch"
        placeholder="请输入房屋地址/业务编号查询"
    >
    </van-search>
    <bv-refresh v-if="show" ref="refresh" :page.sync="page" :limit.sync="limit" :data.sync="indexList" @refresh="fetchData" @load="fetchData">
      <card-detail v-for="(item,index) in indexList" :key="index" class="card--box-shodow" :border="false" >
        <template #title>
          <van-cell :title="'业务编号：'+item.reqNo" :border="false"/>
        </template>
        <template #content>
          <content-item contentLeft="记账时间" :contentRight="item.tallyDate"></content-item>
          <content-item contentLeft="房屋地址" :contentRight="item.address"></content-item>
          <content-item contentLeft="交存模式" :contentRight="item.depositname"></content-item>
          <content-item contentLeft="交存金额" :contentRight="item.realAmount"></content-item>
          <content-item contentLeft="承办银行" :contentRight="item.bankName"></content-item>
        </template>
        <template #footer>
          <div>
            <van-button type="info" round style="height:30px;margin-left: 70%;margin-bottom: 10px;margin-top: 10px"  @click="goInfo(item.houseGuid,item.reqNo,item.realAmount)">
              获取电子票
            </van-button>
          </div>

        </template>
      </card-detail>
    </bv-refresh>
  </div>
</template>

<script>
import {getDepositList} from '@/api/maintainFund/billObtain/index.js'
import CardDetail from '@/components/card-detail.vue'
import ContentItem from '@/components/content-item.vue'
import {checkESign} from '@/api/maintainFund/maintainFund'

export default {
  components:{
    CardDetail,
    ContentItem,
  },
  name: "billObtain",
  data() {
    return {
      show: true,
      value:"",
      showData:"",
      startDate: '',
      endDate: '',
      page: 1,
      limit: 15,
      basic:true,//是否隐藏错误信息
      errorStr:"当前未查询到交存信息",//错误信息
      indexList:[
      //   {"reqNo":"14256456",
      //   "tallyDate":"1",
      //   "address":"2",
      //   "depositName":"3",
      //   "amount":"4.00",
      //   "majorName":"5"
      // },{"reqNo":"14256453",
      //   "tallyDate":"1",
      //   "address":"2",
      //   "depositName":"3",
      //   "amount":"6.56",
      //   "majorName":"5"
      // }
      ],
      isLoadMore:false,//是否加载中
      loadStatus:'loading',//加载样式
      range:["",""]
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    onSearch(value) {
      this.value = value;
      this.page = 1
      this.indexList = [];
      this.basic = true;
      this.$nextTick(()=>{
        this.fetchData()
      })
    },
    fetchData(){
      getDepositList({
        pageNum: this.page,
        pageSize: this.limit,
        startDate:'',
        endDate:'',
        filter:this.value,
        reqType:'owner'//
      }).then((res) => {
            this.isLoadMore = false;//隐藏加载框
            this.indexList = res.data
            if(this.indexList.length===0){
                this.basic = false
                this.errorStr = "当前未查询到交存信息1";
              }else{
                this.basic = true;
                if(res.data.length <this.limit){
                  this.isLoadMore = true
                  this.loadStatus = 'nomore'
                }else{
                  this.isLoadMore = false
                }
              }

          })
          .catch(() => {
            this.isLoadMore = false;//隐藏加载框
          })
    },
    goInfo(houseGuid,reqNo,amount) {
      let owner = {
        houseGuid: houseGuid,
        reqNo:reqNo
      };
      //先检验是否已签署约定书
      checkESign(owner).then(res => {
        if (res.data.retCode === '0000') {
          this.$router.push({path:"/billObtain/downloadInvoice",query:{reqNo:reqNo,houseGuid:houseGuid,amount:amount}})
        }else{
          this.$dialog.alert({message: res.data.retDesc});
        }
      })

    },

  },
}
</script>

<style scoped>

</style>
